import { useSelector } from 'react-redux';
import AgencyNotification from '../components/AgencyNotification';
import { placementOptions } from '../constants';
import useAgencyNotifications from '../hooks/useAgencyNotifications';
import { checkIsLoadedIn } from '../store/slices/user';

const PageLayout = ({ children }) => {
  const pageTopNotifications = useAgencyNotifications(placementOptions.TOP);
  const { loaded } = useSelector(checkIsLoadedIn);
  if (!loaded) return children;
  if (!pageTopNotifications?.length) return children;

  return (
    <>
      <div className="relative">
        {pageTopNotifications.map((notification) => (
          <AgencyNotification
            key={notification.id}
            notification={notification}
            placement={placementOptions.TOP}
            className="mb-0 mt-0 rounded-l-none rounded-b-none rounded-t-none rounded-r-none"
          />
        ))}
      </div>
      {children}
    </>
  );
};

export default PageLayout;
